'use client';

import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ReferralStats } from '@/lib/types/account';
import { fetchInvite, fetchReferralPayments, fetchReferralsDashboard } from './client';
import { ReferralPaymentsResult } from './mappers';
import { InviteDto, ReferralPaymentsQueryParams } from './types';

export const REFERRALS_DASHBOARD_QK = 'referrals-dashboard';
export const INVITE_QK = 'invite';
export const REFERRAL_PAYMENTS_QK = 'referral-payments';

export function useReferralsDashboard() {
  return useQuery<ReferralStats, Error>({
    queryKey: [REFERRALS_DASHBOARD_QK],
    queryFn: async () => {
      return fetchReferralsDashboard();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}

export function useInvite(options?: { enabled?: boolean }) {
  return useQuery<InviteDto, Error>({
    queryKey: [INVITE_QK],
    queryFn: async () => {
      return fetchInvite();
    },
    enabled: options?.enabled ?? true,
    staleTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
}

export function useReferralPayments(
  params?: ReferralPaymentsQueryParams,
  options?: { enabled?: boolean },
) {
  return useQuery<ReferralPaymentsResult, Error>({
    queryKey: [REFERRAL_PAYMENTS_QK, params],
    queryFn: () => fetchReferralPayments(params),
    enabled: options?.enabled ?? true,
    placeholderData: keepPreviousData,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });
}
